<template>
    <div
        class="aon-row"
        :class="[
            { 'dense': dense },
            { 'no-gutters': noGutters },
            { 'wrap': flexWrap }
        ]"
        :style="computedStyles"
    >
        <slot></slot>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    dense: {
        type: Boolean,
        default: false,
    },
    noGutters: {
        type: Boolean,
        default: false,
    },
    alignItems: {
        type: String,
        default: null,
        validator: (val) => {
            return ['center', 'start', 'end', 'flex-start', 'flex-end', 'normal'].includes(val)
        }
    },
    alignContent: {
        type: String,
        default: null,
        validator: (val) => {
            return ['center', 'start', 'end', 'flex-start', 'flex-end', 'normal'].includes(val)
        }
    },
    justifyContent: {
        type: String,
        default: null,
        validator: (val) => {
            return ['center', 'start', 'end', 'flex-start', 'flex-end', 'normal', 'left', 'right', 'space-between', 'space-around', 'space-evenly'].includes(val)
        }
    },
    flexDirection: {
        type: String,
        default: null,
        validator: (val) => {
            return ['row', 'row-reverse', 'column', 'column-reverse'].includes(val)
        }
    },
    flexWrap: {
        type: Boolean,
        default: true
    }
})

const computedStyles = computed(() => {
    return {
        'align-items': props.alignItems,
        'align-content': props.alignContent,
        'justify-content': props.justifyContent,
        'flex-direction': props.flexDirection
    }
})
</script>

<script>
    export default {
        name: 'AonRow'
    }
</script>

<style lang="scss">
@import '../../../sass/grid.scss';

.aon-row {
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;

    &.wrap {
        flex-wrap: wrap;
    }

    &.dense {
        .aon-col {
            padding: calc($gutter / 2);
        }
    }

    &.no-gutters {
        .aon-col {
            padding: 0
        }
    }
}
</style>
